import fetcher from 'api/fetcher';
import { NotificationName } from 'utils/constants/notification';

import urlParser from 'bloko/common/urlParser';

import { addNotification } from 'store/models/notification';

const fetchSaveSettings = (invoice, amount, setEnable) => {
    return (dispatch) => {
        setEnable(false);
        const queryStr = urlParser.stringify({
            invoice_id: invoice.id, // eslint-disable-line camelcase
            amount,
        });
        fetcher
            .post(`/api/v1/backoffice/invoices/manual?${queryStr}`)
            .then(() => {
                window.location.reload();
            })
            .catch(() => {
                setEnable(true);
                dispatch(addNotification(NotificationName.InvoicesPageError));
            });
    };
};

export default fetchSaveSettings;
